// extracted by mini-css-extract-plugin
module.exports = {"badge-width":"100px","text":"Chip_text__HwmOl"};